<template>
	<StandardModal
		small
		open
		:confirmText="$t('common_button_okay')"
		@confirm="close"
		@cancel="close"
		hideCancel
	>
		<template #title>
			<div class="super-group-title">
				<RocketLaunchIcon halo type="regular" class="super-group-icon" />
				<h1 v-text="$t('super_group_dialog_title')" />
			</div>
		</template>
		<div class="super-group-wrapper">
			<div
				class="super-group-desc"
				v-text="$t('super_group_dialog_description')"
			/>
			<div class="super-group-bullet">
				<EyeIcon type="regular" />
				<div class="super-group-bullet-text">
					<div
						class="super-group-bullet-label"
						v-text="$t('super_group_dialog_read_receipts')"
					/>
					<div
						class="super-group-bullet-desc"
						v-text="$t('super_group_dialog_read_receipts_description')"
					/>
				</div>
			</div>
			<div class="super-group-bullet">
				<BellIcon type="regular" />
				<div class="super-group-bullet-text">
					<div
						class="super-group-bullet-label"
						v-text="$t('super_group_dialog_notifications')"
					/>
					<div class="super-group-bullet-desc">
						{{ $t('super_group_dialog_notifications_description') }}
						<a @click="onLinkClick">
							{{ $t('super_group_dialog_review_notifications') }}
						</a>
					</div>
				</div>
			</div>
		</div>
	</StandardModal>
</template>

<script>
import { StandardModal } from '@/components/common'
import { RocketLaunchIcon, EyeIcon, BellIcon } from '@/icons'

export default {
	components: { StandardModal, RocketLaunchIcon, EyeIcon, BellIcon },
	props: ['chatId'],
	emits: ['close'],
	methods: {
		close() {
			this.$emit('close')
		},
		onLinkClick() {
			this.$router.push({ name: 'groupnotifs', params: { id: this.chatId } })
			this.close()
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.super-group-title {
	@include flex(16px);
	.super-group-icon {
		font-size: 18px;
		color: var(--teal-300);
	}
	h1 {
		@include fontFamily(800);
	}
}

.super-group-wrapper {
	@include flex-column(12px);
	padding: 16px;
	.super-group-desc {
		font-size: 15px;
		margin-bottom: 8px;
	}
	.super-group-bullet {
		@include flex(16px);
		align-items: flex-start;
		.pronto-icon {
			color: var(--neutral-800);
		}
		.super-group-bullet-text {
			@include flex-column(4px);
			.super-group-bullet-label {
				font-size: 14px;
				@include fontFamily(900);
			}
			.super-group-bullet-desc {
				font-size: 14px;
				color: var(--neutral-600);
				a {
					cursor: pointer;
					color: var(--blue-300);
					text-decoration: none;
				}
			}
		}
	}
}
</style>
